import axios from 'axios'
import Bridge from '../lib/Bridge'
import { getPlatform } from './getPlatform'

export default () => {
  const _http = axios.create({ withCredentials: true })

  const { isYixinliApp, isZiXunApp } = getPlatform()
  if (isYixinliApp || isZiXunApp) {
    const getToken = () =>
      new Promise((resolve, reject) => {
        const callbackName = 'frontend_lib_axios_getToken' + +new Date()
        let bridge = new Bridge({
          methods: [
            {
              method: callbackName,
              callback: obj => {
                if (typeof obj === 'object' && !!obj.token) {
                  resolve(obj.token)
                } else {
                  resolve('')
                }
              }
            }
          ]
        })
        bridge.call('getToken', {
          callbackName
        })
      })

    _http.formatEnvInterceptor = _http.interceptors.request.use(res => {
      if (isYixinliApp || isZiXunApp) {
        return getToken().then(token => {
          if (res.url.indexOf('?') === -1) {
            res.url += '?token=' + token
          } else {
            res.url += '&token=' + token
          }
          return Promise.resolve(res)
        })
      }
    })
  }

  return _http
}
